import styled from 'styled-components'
import { css, media, colors, radiuses } from 'styles'

const radius = radiuses.medium

const NotificationsToggle = styled.div`
  box-sizing: border-box;
  padding: 1rem;
  z-index: 5;
  position: relative;
  border-radius: ${radius} ${radius} 0 0;
  cursor: pointer;
  font-size: 1.8rem;
  display: flex;
  background-color: ${colors.mainBackground};
  color: ${colors.textMain};

  i {
    border-radius: 50%;
    padding: 0.6rem 0.5rem 0.4rem;
    margin-right: 0.5rem;
    font-size: 1.6rem;
    line-height: 1em;
    width: 1em;
    text-align: center;
  }

  .notification-count {
    position: absolute;
    top: 0.8rem;
    left: 2rem;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 0.9rem;
    border: 0.1rem solid ${colors.mainBackground};
    border-radius: 0.8rem;
    background-color: ${colors.highlight};
    color: ${colors.mainInverted};

    & + .bell {
      margin-top: 0.3rem;
    }
  }

  ${p => !p.hasNotifications && 'opacity: 0.5;'}

  &::after {
    ${p =>
      p.hasNotifications &&
      css`
        content: '';
        display: block;
        position: absolute;
        width: 1rem;
        height: 1rem;
        background-color: ${colors.mainBackground};
        bottom: 0;
        left: -1rem;
        pointer-events: none;
        opacity: 0;
        border-radius: 0 0 1rem;

        ${p.active &&
          css`
            opacity: 1;
            box-shadow: -0.5rem 0rem 0.5rem -0.5rem ${colors.boxShadow} inset,
              0rem -0.5rem 0.5rem -0.5rem ${colors.boxShadow} inset;
          `}
      `}
  }

  ${media.mobile`
    background-color: ${colors.main};
    color: ${colors.mainInverted};

    i {
      font-size: 2.4rem;
      padding: 0.8rem;
      margin-bottom: 0.3rem;
    }

    .notification-count {
      top: 0.6rem;
      left: 3rem;
      width: 2.5rem;
      height: 2.5rem;
      font-size: 1.5rem;
      border-radius: 5rem;
    }

    &::after {
      display: none;
    }
  `}
`

const NotificationsBody = styled.div`
  visibility: hidden;
  position: absolute;
  right: 0;
  z-index: 4;
  width: 36rem;
  padding: 0.5rem;
  border-radius: ${radius} 0 ${radius} ${radius};
  background-color: ${colors.mainBackground};
  box-shadow: 0 0 1rem ${colors.boxShadow};
  max-height: 46rem;
  overflow-y: auto;

  .item-enter,
  .item-exit-active {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
  }
  .item-enter-active {
    max-height: 6rem;
    opacity: 1;
    overflow: hidden;
  }
  .item-enter-active,
  .item-exit-active {
    transition: 0.5s ease-in-out;
  }

  ${media.mobile`
    width: 90vw;
    left: 0;
    border-radius: 0 ${radius} ${radius} ${radius};
  `}
`

const StyledNotificationsPanel = styled.div`
  position: relative;
  border-radius: ${radius} ${radius} 0 0;

  ${p =>
    p.active &&
    p.hasNotifications &&
    css`
      box-shadow: 0 0 1rem ${colors.boxShadow};

      ${NotificationsBody} {
        visibility: visible;
      }
    `};
`

export default StyledNotificationsPanel
export { NotificationsToggle, NotificationsBody }
